import React, { useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import image2 from '../assets/image2.png';

const CompanyStats = () => {
  const [loading, setLoading] = useState(true);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  React.useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="px-6 py-12 lg:py-20 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Left: Text Content */}
        <div className="lg:text-left lg:flex lg:flex-col lg:items-start">
          {loading ? (
            <>
              <Skeleton height={40} width={350} style={{ marginBottom: 24, borderRadius: 8 }} />
              <Skeleton count={3} height={20} width={500} style={{ marginBottom: 8, borderRadius: 8 }} />
              <div className="mt-10 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-8 text-center lg:text-left w-full">
                {Array.from({ length: 4 }).map((_, idx) => (
                  <div key={idx}>
                    <Skeleton height={32} width={60} style={{ margin: '0 auto', borderRadius: 8 }} />
                    <Skeleton height={16} width={100} style={{ margin: '8px auto 0', borderRadius: 8 }} />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <h2 className="text-4xl font-bold leading-tight">
                Building with <span className="text-[#0037AD]">Purpose.</span><br />
                Delivering with <span className="text-[#0037AD]">Precision.</span>
              </h2>
              <p className="mt-6 text-black leading-relaxed">
              Based in Addis Ababa, Ethiopia, Yetwins Construction PLC offers reputable and top-tier construction services that promote precision, safety, and client satisfaction.
              <br />
              Whether it's residential, commercial or infrastructure – from renovations to equipment rentals – our professional team delivers reliability and efficiency to your project. At Yetwins, we are dedicated to developing long-term relationships, and delivering with precision and on time.
              </p>

              {/* Stats */}
              <div ref={ref} className="mt-10 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-8 text-center lg:text-left">
                <div>
                  <p className="text-2xl lg:text-3xl font-bold text-[#0037AD]">
                    {inView ? <CountUp end={15} duration={4.5} /> : 0}+
                  </p>
                  <p className="text-sm lg:text-base text-black mt-1 lg:mt-2 uppercase tracking-wide">Years of Experience</p>
                </div>
                <div>
                  <p className="text-2xl lg:text-3xl font-bold text-[#0037AD]">
                    {inView ? <CountUp end={450} duration={4.5} /> : 0}+
                  </p>
                  <p className="text-sm lg:text-base text-black mt-1 lg:mt-2 uppercase tracking-wide">Completed Projects</p>
                </div>
                <div>
                  <p className="text-2xl lg:text-3xl font-bold text-[#0037AD]">
                    {inView ? <CountUp end={98} duration={4.5} /> : 0}%
                  </p>
                  <p className="text-sm lg:text-base text-black mt-1 lg:mt-2 uppercase tracking-wide">Satisfied Clients</p>
                </div>
                <div>
                  <p className="text-2xl lg:text-3xl font-bold text-[#0037AD]">
                    {inView ? <CountUp end={8} duration={4.5} /> : 0}+
                  </p>
                  <p className="text-sm lg:text-base text-black mt-1 lg:mt-2 uppercase tracking-wide">Awards & Recognition</p>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Right: Image */}
        <div className="lg:flex lg:justify-end">
          {loading ? (
            <Skeleton className="w-full h-64 rounded-md" style={{ height: '256px', borderRadius: 8 }} />
          ) : (
            <img src={image2} alt="Office Building" className="w-full h-auto shadow-md" />
          )}
        </div>
      </div>
    </section>
  );
};

export default CompanyStats;